import Link from 'components/shared/Link/Link';
import Media from 'components/shared/Media/Media';
import { AuthorProps } from '../types';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const BaseWithBlogAuthor = ({ name, title, image, sys, slug }: AuthorProps) => {
  const authorName = <span {...liveUpdateAttrs(sys?.id, 'name')}>{name}</span>;

  return (
    <div className="flex items-center gap-3 mt-12">
      {image && <Media media={image} sizes={'40px'} className={'size-10 rounded-full object-cover'} />}
      <p className="font-serif text-lg">
        {slug ? (
          <Link className="underline" href={slug.startsWith('/') ? slug : `/${slug}`}>
            {authorName}
          </Link>
        ) : (
          authorName
        )}
        {title && <span {...liveUpdateAttrs(sys?.id, 'title')}>, {title}</span>}
      </p>
    </div>
  );
};

export default BaseWithBlogAuthor;
